// extracted by mini-css-extract-plugin
module.exports = {"listingLine":"SummaryRow_listingLine__Xecoz","listingLineText":"SummaryRow_listingLineText__CGIoT","listingLinePrice":"SummaryRow_listingLinePrice__jPjQU"};